import React, { useRef,useState,useEffect} from "react";
import "./ContactUs.scss"; // Import the SCSS file
import {emailSender} from "../services/EmailSender";
import CustomMessage from "../more/CustomMessage"


const ContactUs = () => {
  const [submitted, setSumited] = useState(false);
  const componenteRef = useRef(null);
  const [isMessageErrorOpen, setIsMessageErrorOpen] =  useState(false);

  useEffect(() => {
      const what = localStorage.getItem("ContactUsSumit")
      if(what !== null)
      setSumited(true)
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (componenteRef.current && !componenteRef.current.contains(event.target)) 
        setIsMessageErrorOpen(false);
    }
      document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // State to manage form inputs
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
  
    emailSender(formData)
      .then(() => {
        localStorage.setItem("ContactUsSumit", "hola");
        setSumited(true)
        setFormData({
          name: "",
          email: "",
          phone: "",
          description: "",
        });
      })
      .catch(() => {
        setIsMessageErrorOpen(true);
      });
  };
  
  return (
    <div className="contact-container">
      <div className="form-box">
        <h1 className="form-heading">Contact Us</h1>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter your name"
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Enter your phone number"
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter your message"
              required
              className="form-textarea"
            />
          </div>
          {submitted
          ?<center><p>We've got your message! We'll review it and be in touch soon.</p></center>
          :<button type="submit" className="submit-button">
              Submit
          </button>
          }     
        </form>
      </div>
      {isMessageErrorOpen && (<div className="overlayMessage"><div ref={componenteRef}> 
                <CustomMessage
                message= {"We're sorry, but we encountered an issue while sending your message. " +
                          "Please try again later or reach out using one of our contact options. " +
                          "Thank you for your patience!"}
                onConfirm={()=>{setIsMessageErrorOpen(false)}}
                /></div></div>
            )}
    </div>
  );
};

export default ContactUs;